import { Components, Theme } from '@mui/material/styles'

export const formLabelTheme: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    asterisk: ({ theme }) => ({
      color: theme.palette.error.main,
    }),
  },
}
